import type { ContestStatus } from '~/domains/contest/domains/services/enums/contests-status.enum';
import type { UserContestAssociation } from '~/domains/contest/domains/services/enums/user-contest-association.enum';
import type { ActiveTab } from '~/domains/commissioner/enums';
import type { ChannelContestFilter } from '~/domains/channel/enums';

import { useChannelContestsV2 } from './useChannelContestsV2';
import { useChannelContestsProfileV2 } from './useChannelContestsProfileV2';

export const useChannelContests = ({
  userId,
  activeTab,
  channelContestFilter,
  contestStatus,
  isCommissionerHub,
  association,
}: {
  userId: string;
  activeTab?: ActiveTab;
  channelContestFilter?: ChannelContestFilter;
  contestStatus?: ContestStatus;
  isCommissionerHub?: boolean;
  association?: UserContestAssociation;
}) => {
  const commissionerHubResult = useChannelContestsV2({
    activeTab,
    contestStatus,
    enabled: !!isCommissionerHub,
  });

  const profileResult = useChannelContestsProfileV2({
    userId,
    channelContestFilter,
    contestStatus,
    association,
    enabled: !isCommissionerHub,
  });

  return isCommissionerHub ? commissionerHubResult : profileResult;
};
